module.exports = __webpack_public_path__ + "components/app-store/static/s2-c22cfac3af452b474aea56b185a11f52.jpg";